module.exports = __webpack_public_path__ + "static/media/Image.297b0240.svg";